import React from 'react'
import { graphql, Link } from 'gatsby'

import SiteLayout from '../components/site_layout'

const AboutPage = ({ data }) => {
  console.log(data.posts.totalCount);

  return (
    <SiteLayout location="/about/">
      <h1>{data.site.siteMetadata.title}</h1>
      <div>
        <h1>{data.markdown.frontmatter.title}</h1>
        <h2>{data.markdown.frontmatter.date}</h2>
        <br/>
        <div dangerouslySetInnerHTML={{ __html: data.markdown.html }} />
      </div>
    </SiteLayout>
  )
}

export default AboutPage

export const query = graphql`
  query AboutQuery {
    site {
      siteMetadata {
        title
      }
    }
    posts: allMarkdownRemark {
      totalCount
      edges {
        node {
          id
          html
          frontmatter {
            title
            date(formatString: "DD MMMM, YYYY")
          }
          excerpt
        }
      }
    }
    markdown: markdownRemark(frontmatter: { path: { eq: "content" } }) {
        html
        frontmatter {
          date(formatString: "MMMM DD, YYYY")
          path
          title
        }
    }
  }
`

/*
<Link to="/tensorflow/">Tensorflow</Link>
<br/>
<Link to="/markdown/">Markdown Page</Link>
*/

/*
        <p>Friends</p>
        <div>{ data.markdown.html }</div>
 */